import { groq } from "next-sanity";
import { handleClientError } from "../../errors";
import { getClient } from "../sanity";

export type SqlCategory = {
  slug: string;
  name: string;
};

export type SqlPageSimple = {
  slug: string;
  name: string;
  order: number;
  categoryName: string;
};

export type SqlPage = {
  createdAt: string;
  updatedAt: string;
  slug: string;
  name: string;
  order: number;
  category: SqlCategory;
  content: string;
  related: SqlPageSimple[];
  metaTitle?: string;
  metaDescription?: string;
};

export const getSqlPage = async (slug: string): Promise<SqlPage | undefined> => {
  const query = groq`
    *[_type == "sqlPage" && slug == $slug] {
      'createdAt': _createdAt,
      'updatedAt': _updatedAt,
      slug,
      name,
      order,
      content,
      metaTitle,
      metaDescription,
      category->{ slug, name },
      related[]->{ slug, name, order, 'categoryName': category->name },
    }
  `;

  try {
    const parameters = { slug };
    const sqlPage = await getClient().fetch(query, parameters);
    return sqlPage[0];
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    handleClientError(`Failed to fetch SQL page with slug "${slug}": ${errorMessage}`);
    return undefined;
  }
};

export const getSqlPages = async (): Promise<SqlPageSimple[]> => {
  const query = groq`
    *[_type == "sqlPage"] {
      slug,
      name,
      order,
      'categoryName': category->name
    } | order(order)
  `;

  try {
    const sqlPages = await getClient().fetch(query);
    return sqlPages;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    handleClientError(`Failed to fetch SQL pages: ${errorMessage}`);
    return [];
  }
};
